var data = [
  {
    date: "2023-2-24",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-3-4",
    event: "",
    text: "名古屋鍼灸セミナー",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-3-7",
    event: "",
    text: "マスタークラス",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-3-9",
    event: "",
    text: "オンラインZOOMセミナー",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-3-11",
    event: "",
    text: "大阪/東京鍼灸セミナー",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-3-15",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "名古屋ソムリエ",
    lottery_date01: "2023-3-16",
    lottery_bg01: "#00bf63",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-3-16",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "東京頭骨ソムリエ",
    lottery_date02: "2023-3-17",
    lottery_bg02: "#ffbd59",
  },
  {
    date: "2023-3-19",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "大阪ソムリエ",
    lottery_date01: "2023-3-20",
    lottery_bg01: "#004aad",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-3-20",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "福岡ソムリエ",
    lottery_date02: "2023-3-21",
    lottery_bg02: "#f2766e",
  },
  {
    date: "2023-3-22",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "東京ソムリエ",
    lottery_date01: "2023-3-23",
    lottery_bg01: "#ffbd59",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-4-8",
    event: "",
    text: "大阪/東京鍼灸セミナー",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-4-12",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "東京ソムリエ",
    lottery_date01: "2023-4-13",
    lottery_bg01: "#ffbd59",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-4-13",
    event: "",
    text: "オンラインセミナー",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-4-16",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "大阪ソムリエ",
    lottery_date01: "2023-4-17",
    lottery_bg01: "#004aad",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-4-17",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "福岡ソムリエ",
    lottery_date02: "2023-4-18",
    lottery_bg02: "#f2766e",
  },
  {
    date: "2023-4-19",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "名古屋ソムリエ",
    lottery_date01: "2023-4-20",
    lottery_bg01: "#00bf63",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-4-20",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "東京頭骨ソムリエ",
    lottery_date02: "2023-4-21",
    lottery_bg02: "#ffbd59",
  },
  {
    date: "2023-5-11",
    event: "",
    text: "オンラインセミナー",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-5-13",
    event: "",
    text: "大阪/東京鍼灸セミナー",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-5-15",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "福岡ソムリエ",
    lottery_date02: "2023-5-16",
    lottery_bg02: "#f2766e",
  },
  {
    date: "2023-5-17",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "東京ソムリエ",
    lottery_date01: "2023-5-18",
    lottery_bg01: "#ffbd59",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-5-18",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "東京頭骨ソムリエ",
    lottery_date02: "2023-5-19",
    lottery_bg02: "#ffbd59",
  },
  {
    date: "2023-5-21",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "大阪ソムリエ",
    lottery_date01: "2023-5-22",
    lottery_bg01: "#004aad",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-5-24",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "名古屋ソムリエ",
    lottery_date01: "2023-5-25",
    lottery_bg01: "#00bf63",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-6-3",
    event: "",
    text: "名古屋鍼灸セミナー",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-6-15",
    event: "",
    text: "朝活オンラインセミナー",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-6-10",
    event: "",
    text: "大阪/東京鍼灸セミナー",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-6-14",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "東京ソムリエ",
    lottery_date01: "2023-6-15",
    lottery_bg01: "#ffbd59",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-6-15",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "東京頭骨ソムリエ",
    lottery_date02: "2023-6-16",
    lottery_bg02: "#ffbd59",
  },
  {
    date: "2023-6-18",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "大阪ソムリエ",
    lottery_date01: "2023-6-19",
    lottery_bg01: "#004aad",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-6-19",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "福岡ソムリエ",
    lottery_date02: "2023-6-20",
    lottery_bg02: "#f2766e",
  },
  {
    date: "2023-6-21",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "名古屋ソムリエ",
    lottery_date01: "2023-6-22",
    lottery_bg01: "#00bf63",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
   {
    date: "2023-6-24",
    event: "",
    text: "夜活オンラインセミナー",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-7-8",
    event: "",
    text: "大阪/東京鍼灸セミナー",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-7-12",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "東京小顔ソムリエ",
    lottery_date01: "2023-7-13",
    lottery_bg01: "#ffbd59",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-7-21",
    event: "",
    text: "朝活オンラインセミナー",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-7-17",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "大阪小顔ソムリエ",
    lottery_date01: "2023-7-18",
    lottery_bg01: "#004aad",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-7-17",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "福岡小顔ソムリエ",
    lottery_date02: "2023-7-18",
    lottery_bg02: "#f2766e",
  },
  {
    date: "2023-7-19",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "名古屋小顔ソムリエ",
    lottery_date01: "2023-7-20",
    lottery_bg01: "#00bf63",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-7-20",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "東京頭骨ソムリエ",
    lottery_date02: "2023-7-21",
    lottery_bg02: "#ffbd59",
  },
   {
    date: "2023-7-22",
    event: "",
    text: "夜活オンラインセミナー",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
   {
    date: "2023-8-8",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "大阪頭骨ソムリエ",
    lottery_date01: "2023-8-9",
    lottery_bg01: "#004aad",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-8-12",
    event: "",
    text: "大阪/東京鍼灸セミナー",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-8-16",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "東京小顔ソムリエ",
    lottery_date01: "2023-8-17",
    lottery_bg01: "#ffbd59",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-8-17",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "東京頭骨ソムリエ",
    lottery_date02: "2023-8-18",
    lottery_bg02: "#ffbd59",
  },
    {
    date: "2023-8-18",
    event: "",
    text: "朝活オンラインセミナー",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-8-23",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "名古屋小顔ソムリエ",
    lottery_date01: "2023-8-24",
    lottery_bg01: "#00bf63",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
   {
    date: "2023-8-28",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "大阪小顔ソムリエ",
    lottery_date01: "2023-8-29",
    lottery_bg01: "#004aad",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
   {
    date: "2023-8-31",
    event: "",
    text: "マスタークラス",
    link: "",
    bg: "#FF6347",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
   {
    date: "2023-9-2",
    event: "",
    text: "名古屋鍼灸セミナー",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",	
    lottery_bg02: "",
  },
  {
    date: "2023-9-9",
    event: "",
    text: "大阪/東京鍼灸セミナー",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-9-9",
    event: "",
    text: "",
    link: "",
    bg: "",
    display_txt:"on",
    lottery01: "夜活オンラインセミナー",
    lottery_date01: "2023-9-9",
    lottery_bg01: "	#FF3399",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
   {
    date: "2023-9-12",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "大阪頭骨ソムリエ",
    lottery_date02: "2023-9-13",
    lottery_bg02: "#004aad",
  },
  {
    date: "2023-9-13",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "東京小顔ソムリエ",
    lottery_date01: "2023-9-14",
    lottery_bg01: "#ffbd59",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-9-19",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "#004aad",
    lottery02: "大阪小顔ソムリエ",
    lottery_date02: "2023-9-20",
    lottery_bg02: "#004aad",
  },
  {
    date: "2023-9-20",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "名古屋小顔ソムリエ",
    lottery_date01: "2023-9-21",
    lottery_bg01: "#00bf63",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-9-21",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "東京頭骨ソムリエ",
    lottery_date02: "2023-9-22",
    lottery_bg02: "#ffbd59",
  },
     {
    date: "2023-9-25",
    event: "",
    text: "マスタークラス",
    link: "",
    bg: "#FF6347",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
   {
    date: "2023-9-26",
    event: "",
    text: "朝活オンラインセミナー",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-10-14",
    event: "",
    text: "大阪/東京鍼灸セミナー",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-10-18",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "東京小顔ソムリエ",
    lottery_date01: "2023-10-19",
    lottery_bg01: "#c71585",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-10-19",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "東京頭骨ソムリエ",
    lottery_date02: "2023-10-20",
    lottery_bg02: "#fa8072",
  },
  {
    date: "2023-10-22",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "大阪小顔ソムリエ",
    lottery_date01: "2023-10-23",
    lottery_bg01: "#004aad",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
       {
    date: "2023-10-27",
    event: "",
    text: "無料勉強会",
    link: "",
    bg: "#ffa500",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
   {
    date: "2023-10-28",
    event: "",
    text: "",
    link: "",
    bg: "",
    display_txt:"on",
    lottery01: "オンラインセミナー",
    lottery_date01: "2023-10-28",
    lottery_bg01: "#3cb371",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
   {
    date: "2023-11-4",
    event: "",
    text: "名古屋鍼灸セミナー",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",	
    lottery_bg02: "",
  },
  {
    date: "2023-11-11",
    event: "",
    text: "大阪/東京鍼灸セミナー",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
         {
    date: "2023-11-12",
    event: "",
    text: "東京無料勉強会",
    link: "",
    bg: "#ffa500",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-11-15",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "東京小顔ソムリエ",
    lottery_date01: "2023-11-16",
    lottery_bg01: "#c71585",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-11-16",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "東京頭骨ソムリエ",
    lottery_date02: "2023-11-17",
    lottery_bg02: "#fa8072",
  },
  {
    date: "2023-11-19",
    event: "",
    text: "大阪無料勉強会",
    link: "",
    bg: "#ffa500",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-11-19",
    event: "",
    text: "",
    link: "",
    bg: "",
    display_txt:"on",
    lottery01: "大阪小顔ソムリエ",
    lottery_date01: "2023-11-20",
    lottery_bg01: "#004aad",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
       {
    date: "2023-11-28",
    event: "",
    text: "マスタークラス",
    link: "",
    bg: "#FF6347",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-12-9",
    event: "",
    text: "大阪/東京鍼灸セミナー",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-12-13",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "東京小顔ソムリエ",
    lottery_date01: "2023-12-14",
    lottery_bg01: "#c71585",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-12-17",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "大阪小顔ソムリエ",
    lottery_date01: "2023-12-18",
    lottery_bg01: "#004aad",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-12-21",
    event: "",
    text: "名古屋鍼灸セミナー",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
  {
    date: "2023-12-21",
    event: "",
    text: "",
    link: "",
    bg: "",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "東京頭骨ソムリエ",
    lottery_date02: "2023-12-22",
    lottery_bg02: "#fa8072",
  },
  {
    date: "2023-12-28",
    event: "",
    text: "オンラインセミナー",
    link: "",
    bg: "",
    display_txt:"on",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
          {
    date: "2023-12-30",
    event: "",
    text: "東京無料勉強会",
    link: "",
    bg: "#ffa500",
    lottery01: "",
    lottery_date01: "",
    lottery_bg01: "",
    lottery02: "",
    lottery_date02: "",
    lottery_bg02: "",
  },
];